/** "¿Está listo para abrir?" — warnings only; the user decides */

import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import type { Event } from '@/types/event.types';
import { useEventSessions } from '../hooks';
import { usePricingRules } from '../hooks/usePricingRules';
import { getReadinessChecks } from '../utils/eventReadiness';

export function ReadinessChecklist({ event }: { event: Event }) {
  const { rules, isLoading: loadingRules } = usePricingRules(event.id);
  const { data: sessions = [], isLoading: loadingSessions } = useEventSessions(event.id);

  if (loadingRules || loadingSessions) {
    return <p className="text-sm text-muted-foreground">Revisando configuración…</p>;
  }

  const checks = getReadinessChecks(event, rules.filter((r) => r.is_active).length, sessions.length);
  const warnings = checks.filter((c) => !c.ok);

  return (
    <div className="space-y-2 rounded-md border bg-muted/30 p-3 text-sm">
      <p className="font-medium">
        {warnings.length === 0 ? 'Todo listo para abrir.' : `Revise antes de abrir (${warnings.length}):`}
      </p>
      <ul className="space-y-1">
        {checks.map((c) => (
          <li key={c.id} className="flex items-start gap-2">
            {c.ok ? (
              <CheckCircle2 className="mt-0.5 size-4 shrink-0 text-green-600" />
            ) : (
              <AlertTriangle className="mt-0.5 size-4 shrink-0 text-amber-600" />
            )}
            <span className={c.ok ? 'text-muted-foreground' : undefined}>
              {c.label}
              {!c.ok && c.hint && <span className="block text-xs text-muted-foreground">{c.hint}</span>}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
